import { Link } from "@/components/LocalizedLink";
import { ArrowRight, FileText, FileDown, CheckCircle2, ShieldCheck } from "lucide-react";
import { useTranslation } from "react-i18next";

/** Säljyta för Egenkontrollpärmen – används på startsidan och prissidan. */
export function BinderPromo({ className = "" }: { className?: string }) {
  const { t } = useTranslation();
  const points = t("aBinder.points", { returnObjects: true }) as string[];

  return (
    <section className={`container-page ${className}`} data-android-hide>
      <div className="mx-auto max-w-5xl rounded-3xl border-2 border-accent/50 bg-gradient-to-br from-accent/[0.07] via-card to-card p-6 sm:p-10 shadow-elevated ring-1 ring-accent/10">
        <div className="grid gap-8 sm:grid-cols-5 sm:items-center">
          <div className="sm:col-span-3">
            <span className="inline-flex items-center gap-2 rounded-full bg-accent px-3 py-1 text-xs font-semibold text-accent-foreground">
              <FileText className="h-3.5 w-3.5" /> {t("aBinder.badge")}
            </span>
            <h2 className="mt-3 font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight">
              {t("aBinder.title")}
            </h2>
            <p className="mt-3 text-muted-foreground">
              {t("aBinder.buyDirect")}<span className="font-semibold text-foreground">{t("aBinder.noMembership")}</span>
              {t("aBinder.regularPrice")}<span className="font-semibold text-foreground">{t("aBinder.price790")}</span>
              {t("aBinder.or")}<span className="font-semibold text-foreground">{t("aBinder.price395")}</span>
              {t("aBinder.premiumMember")}
            </p>
            <p className="mt-3 rounded-xl border border-success/30 bg-success/10 px-4 py-3 text-sm font-semibold text-foreground">
              {t("aBinder.includedNotice")}
              <Link to="/pricing" className="underline">{t("aBinder.premium90")}</Link>
              {t("aBinder.freeValue")}
            </p>

            <ul className="mt-5 space-y-2.5 text-sm">
              {points.map((p) => (
                <li key={p} className="flex items-start gap-2">
                  <CheckCircle2 className="mt-0.5 h-4 w-4 text-success shrink-0" />
                  <span>{p}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="sm:col-span-2 flex flex-col gap-3">
            <div className="rounded-2xl border border-border bg-background p-5 text-center">
              <div className="text-sm text-muted-foreground">{t("aBinder.withoutMembership")}</div>
              <div className="font-display text-3xl font-bold">{t("aBinder.price790")}</div>
              <div className="mt-3 border-t border-border pt-3 text-sm text-muted-foreground">
                {t("aBinder.asPremium")}
              </div>
              <div className="font-display text-3xl font-bold text-accent">{t("aBinder.price395")}</div>
              <div className="mt-1 text-xs text-muted-foreground">{t("aBinder.incVat")}</div>
            </div>
            <Link
              to="/egenkontrollparm"
              className="inline-flex items-center justify-center gap-2 rounded-xl bg-primary px-5 py-3.5 text-sm font-semibold text-primary-foreground hover:bg-primary/90 shadow-elevated"
            >
              {t("aBinder.cta")} <ArrowRight className="h-4 w-4" />
            </Link>
            <div className="flex flex-col items-center gap-1 text-xs text-muted-foreground">
              <span className="inline-flex items-center gap-1.5">
                <FileDown className="h-3.5 w-3.5" /> {t("aBinder.downloadInfo")}
              </span>
              <span className="inline-flex items-center gap-1.5">
                <ShieldCheck className="h-3.5 w-3.5" /> {t("aBinder.securityInfo")}
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
